/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-empty-pattern */
import React, { useEffect, useState } from "react";

import toast from "react-hot-toast";
import {
  Button,
  Chip,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTokenStore } from "../../Zustand/TokenStore";
import { Box } from "@mui/system";

import { useNavigate } from "react-router";
import AxiosInstance from "../../API/axios";
import { BASE_API_URL } from "../../API/Base";
import Layout from "../../Components/Layout";

type Props = {};

type Page = {
  Page_Id: number;
  Page_Name: string;
  Page_Url: string;
  Page_Icon: string;
  Permissions: Permission;
};
type Permission = {
  Actions: Action[];
};

type Action = {
  ActionsId: number;
  ActionName: string;
  Status: boolean;
};

interface Role {
  Role_Name: string;
  isStatus: boolean;
  PagesAndActions: PagesWithActions[];
}

interface PagesWithActions {
  Page_Id: number; // Change this to number
  Actions: number[];
}

function RoleAdd({}: Props) {
  const navigator = useNavigate();
  // const theme: Theme = useThemeStore((state) => state.theme);

  const [pages, setPages] = useState<Page[]>([]);
  const [selectedActions, setSelectedActions] = useState<
    Record<string, number[]>
  >({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSwitchChange = (
    pageId: number,
    actionId: number,
    isSelected: boolean
  ) => {
    setSelectedActions((prevSelectedActions) => {
      const updatedActions = new Set(prevSelectedActions[pageId] || []);
      if (isSelected) {
        updatedActions.add(actionId);
      } else {
        updatedActions.delete(actionId);
      }
      return {
        ...prevSelectedActions,
        [pageId]: Array.from(updatedActions),
      };
    });
  };

  const renderModalContent = () => {
    return (
      <Box className="absolute top-1/2 left-1/2 w-11/12 h-[90%] transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-md px-8 pb-8 min-w-[400px] flex flex-col items-center gap-y-4 ">
        <Typography variant="h6" gutterBottom>
          Role Details
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Role Name: {watch("Role_Name")}
        </Typography>
        <div className="flex flex-col items-center w-full">
          <div className="flex flex-row items-center justify-center w-full h-12 text-white bg-primary">
            <h1>Permissions</h1>
          </div>
          <div className="grid items-center w-full h-16 grid-cols-12 border-b divide-x  border-x divide-primary border-slate-500 justify-normal">
            <div className="flex flex-row items-center justify-center h-full col-span-1 ">
              <h3 className="text-lg font-semibold text-primary ">ID</h3>
            </div>
            <div className="flex flex-row items-center justify-center h-full col-span-2 ">
              <h3 className="text-lg font-semibold text-primary ">Name</h3>
            </div>
            <div className="flex flex-col items-center justify-start h-full col-span-9 divide-y divide-primary">
              <h3 className="text-lg font-semibold text-primary ">Actions</h3>
              <div className="flex flex-row items-center justify-center w-full divide-primary">
                <div className="flex flex-row items-center justify-center w-1/4 ">
                  <h3>Action Name</h3>
                </div>
                <div className="flex flex-row items-center justify-center w-3/4">
                  <h3>Permission</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full overflow-hidden overflow-y-auto h-72">
            {pages.map((page, pageIndex) => (
              <div
                className="grid items-center w-full grid-cols-12 border-b divide-x bg-primary/15 border-x divide-slate-500 border-slate-500 justify-normal"
                key={pageIndex}
              >
                <div className="flex flex-row items-center justify-center h-full col-span-1 ">
                  <h3 className="text-lg font-semibold text-primary">
                    {pageIndex + 1}
                  </h3>
                </div>
                <div className="flex flex-row items-center justify-center h-full col-span-2 ">
                  <h3 className="text-lg font-normal text-black">
                    {page.Page_Name}
                  </h3>
                </div>
                <div className="flex flex-row items-center justify-start h-full col-span-9 p-2 gap-x-2">
                  {page.Permissions.Actions.map((action, actionIndex) => {
                    const isSelected = selectedActions[page.Page_Id]?.includes(
                      action.ActionsId
                    );
                    return (
                      <Chip
                        key={actionIndex}
                        label={action.ActionName}
                        clickable
                        onClick={() =>
                          handleSwitchChange(
                            page.Page_Id,
                            action.ActionsId,
                            !isSelected
                          )
                        }
                        color={isSelected ? "success" : "default"}
                        variant={isSelected ? "filled" : "outlined"}
                        style={{
                          margin: "4px",
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-row items-center justify-center gap-x-4">
          <Button
            variant="contained"
            sx={{ color: "#fff" }}
            onClick={closeModal}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ color: "#fff" }}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
        </div>
      </Box>
    );
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Role>();

  const onSubmit: SubmitHandler<Role> = async (data: Role) => {
    // Create the PagesAndActions array based on selectedActions
    const pagesAndActions: PagesWithActions[] = Object.keys(
      selectedActions
    ).map((pageId) => ({
      Page_Id: Number(pageId), // Convert Page_Id to a number here
      Actions: selectedActions[pageId],
    }));

    // Include the PagesAndActions in the Role data
    const roleData: Role = {
      ...data,
      PagesAndActions: pagesAndActions,
    };
    console.log(roleData);
    closeModal();
    try {
      const res = await AxiosInstance.post(
        "/admin/roles/v1/create-role",
        roleData
      );
      if (res.status === 200) {
        toast.success("Role Created Successfully");
        const insertid = res.data.Role_Id;

        navigator("/roles/manage");
      } else {
        toast.error("Error Occured");
      }
    } catch (err) {
      if ((err as any).response.status === 406) {
        toast.error("Role Already Exists");
        return;
      }
      toast.error("Error Occured");
      console.log(err);
    }
  };

  //get pages list from modules
  const getPages = async () => {
    try {
      const res = await AxiosInstance.get(
        `${BASE_API_URL}/admin/roles/v1/get-pages-with-permissions`
      );
      const allPages: Page[] = res.data;
      console.log(allPages);
      setPages(allPages);
    } catch (err) {
      console.log(err);
    }
  };

  const handleCheckAll = (pageId: number, actions: { ActionsId: number }[]) => {
    setSelectedActions((prevSelectedActions) => {
      const currentActions = new Set(prevSelectedActions[pageId] || []);
      if (isAllSelected(pageId)) {
        // If all were selected, deselect them
        actions.forEach((action) => currentActions.delete(action.ActionsId));
      } else {
        // Otherwise, select all actions
        actions.forEach((action) => currentActions.add(action.ActionsId));
      }
      return {
        ...prevSelectedActions,
        [pageId]: Array.from(currentActions),
      };
    });
  };

  const isAllSelected = (pageId: number): boolean => {
    const currentPageActions =
      pages
        .find((page) => page.Page_Id === pageId)
        ?.Permissions.Actions.map((action) => action.ActionsId) || [];
    const selectedForPage = selectedActions[pageId] || [];
    return (
      currentPageActions.length > 0 &&
      currentPageActions.every((actionId) => selectedForPage.includes(actionId))
    );
  };

  useEffect(() => {
    console.log(useTokenStore.getState().AuthData);
    getPages();
  }, []);
  return (
    <Layout PageId={7}>
      <div className="flex flex-col w-full mb-16 gap-y-2 mt-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-row w-full justify-normal gap-x-8">
            <TextField
              id="outlined-basic"
              label="Role Name"
              error={Boolean(errors.Role_Name)}
              variant="outlined"
              required={true}
              {...register("Role_Name", {
                required: "This Field Is Required",
              })}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                "& .MuiInputLabel-root": {
                  color: "#000",
                  "&.Mui-focused": {
                    color: "#000",
                  },
                },
                "& .MuiInputLabel-shrink": {
                  color: "#00A99D",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#00A99D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#00A99D",
                  },

                  "& .MuiInputBase-input": {
                    color: "#000",
                    fontSize: "14px",
                  },
                },
              }}
            />
            <div className="flex flex-row items-center justify-center">
              <h3 className="text-xl font-normal text-black">Status</h3>
              <Switch
                {...register("isStatus")}
                defaultChecked
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
          </div>
        </form>
        <div className="flex flex-col ">
          <div className="flex flex-row items-center justify-center w-full h-12 border-b bg-primary border-slate-500">
            <h3 className="text-xl font-bold text-white">Permissions</h3>
          </div>
          <div className="grid items-center w-full h-12 grid-cols-12 border-b divide-x bg-primary/15 border-x divide-primary border-slate-500 justify-normal">
            <div className="flex flex-row items-center justify-center h-full col-span-1">
              <h3 className="text-lg font-semibold text-primary ">ID</h3>
            </div>
            <div className="flex flex-row items-center justify-center h-full col-span-2">
              <h3 className="text-lg font-semibold text-primary ">Name</h3>
            </div>
            <div className="flex flex-col items-center justify-center h-full col-span-9 divide-y divide-primary">
              <h3 className="text-lg font-semibold text-primary ">Actions</h3>
            </div>
          </div>
          {pages.map((page, pageIndex) => (
            <div
              key={pageIndex}
              className="grid items-center w-full grid-cols-12 border-b divide-x bg-primary/15 border-x divide-slate-500 border-slate-500"
            >
              <div className="flex flex-row flex-wrap items-center justify-center h-full col-span-1">
                <h3 className="text-base font-semibold text-primary ">
                  {pageIndex + 1}
                </h3>
              </div>
              <div className="flex flex-row flex-wrap items-center justify-center h-full col-span-2 place-content-center">
                <h3 className="text-base font-normal text-black ">
                  {page.Page_Name}
                </h3>
              </div>
              <div className="flex flex-row flex-wrap items-center justify-start h-full col-span-9 p-2 gap-x-1 gap-y-2">
                <Chip
                  label="Allow All"
                  clickable
                  onClick={() =>
                    handleCheckAll(page.Page_Id, page.Permissions.Actions)
                  }
                  sx={{
                    color: "#000",
                  }}
                  color={isAllSelected(page.Page_Id) ? "primary" : "default"}
                  variant="outlined"
                  style={{
                    backgroundColor: isAllSelected(page.Page_Id)
                      ? "#4caf50"
                      : "",
                    color: isAllSelected(page.Page_Id) ? "#fff" : "",
                  }}
                />
                {page.Permissions.Actions.map((action, actionIndex) => {
                  const isSelected = selectedActions[page.Page_Id]?.includes(
                    action.ActionsId
                  );
                  return (
                    <Chip
                      key={actionIndex}
                      label={action.ActionName}
                      clickable
                      onClick={() =>
                        handleSwitchChange(
                          page.Page_Id,
                          action.ActionsId,
                          !isSelected
                        )
                      }
                      sx={{
                        color: "#000",
                      }}
                      color={isSelected ? "success" : "default"}
                      variant={isSelected ? "filled" : "outlined"}
                      className="my-2" // Add margin to the top and bottom of chips
                    />
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-row items-center justify-center w-full">
          <div className="flex flex-row items-center justify-start w-1/2 gap-x-2">
            <Button
              type="button"
              onClick={openModal}
              variant="contained"
              color="primary"
              sx={{ color: "white" }}
            >
              Review and Submit
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ color: "#fff" }}
              onClick={handleSubmit(onSubmit)}
            >
              Submit
            </Button>
          </div>
          <div className="flex flex-row items-center justify-end w-1/2">
            <Button
              variant="outlined"
              onClick={() => {
                navigator(-1);
              }}
              sx={{
                color: "#000",
                border: "1px solid #000",
              }}
            >
              Go Back
            </Button>
          </div>
        </div>
      </div>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="flex flex-row items-center justify-center"
      >
        {renderModalContent()}
      </Modal>
    </Layout>
  );
}

export default RoleAdd;
